// | ------------------------------------------------------------------------
// | Imports
// | ------------------------------------------------------------------------

// Bootstrap ----------------------------------------------------------------

import "@popperjs/core"; // Popper is required for dropdowns, popovers and tooltips.
import {
  Alert,
  Button,
  Carousel,
  Collapse,
  Dropdown,
  Modal,
  OffCanvas,
  Popover,
  ScrollSpy,
  Tab,
  Toast,
  Tooltip,
} from "bootstrap";

// Bootstrap overrides, calls and template integration
import "./bootstrap/collapse";
import "./bootstrap/modals";
import "./bootstrap/offcanvas";
import "./bootstrap/popovers";
import "./bootstrap/tooltips";

// Imports used in shop components ------------------------------------------

//? https://kingsora.github.io/OverlayScrollbars/
import { OverlayScrollbars } from "overlayscrollbars"; // Used in /components/shop/productFilters

//? https://splidejs.com/
import Splide from "@splidejs/splide"; // Used in /components/shop/productGallery

//? https://github.com/biati-digital/glightbox
import GLightbox from "glightbox/dist/js/glightbox.js"; // Used in /components/shop/productGallery

// Other imports ------------------------------------------------------------

//? https://github.com/michalsnik/aos
import AOS from "aos"; // Used in /components/animateOnScroll

//? https://simpleparallax.com/
import simpleParallax from "simple-parallax-js"; // Used in /components/parallaxSections

//? https://github.com/yowainwright/shav
import shave from "shave"; // Used in /components/ellipsis

// | ------------------------------------------------------------------------
// | Components
// | ------------------------------------------------------------------------

// Cookie popup
import "./components/cookiePopup";

// | Layout -----------------------------------------------------------------

import "./components/fixedHeader";

// | Navigation -------------------------------------------------------------

import "./components/mainNavigation";
import "./components/dropdownOnHover";

// | Content ----------------------------------------------------------------

import "./components/modernizr-webp"; // Allow background images to fallback to jpegs
import "./components/ellipsis"; // Allows us to restrict text content using ellipsis

// | Animations -------------------------------------------------------------

import "./components/animateOnScroll"; // Animate elements on page scroll
import "./components/heroParallaxBlur"; // Parallax, blur and fade hero background image on scroll
import "./components/parallaxSections"; // Parallax backgrounds for page sections

// | Shop specific ----------------------------------------------------------

import "./components/shop/productFilters";
import "./components/shop/productGallery";
import "./components/shop/productGrid";
import "./components/shop/quantityInputs";

// | ------------------------------------------------------------------------
// | Code
// | ------------------------------------------------------------------------

document.addEventListener("DOMContentLoaded", function () {

  var logoCarousel = document.querySelector(".logo-carousel");

  if (logoCarousel) {
    var logos = new Splide(".logo-carousel", {
      type: "loop",
      autoplay: true,
      perPage: 4,
      perMove: 1,
      pagination: false,
      gap: "var(--global-spacing)",
      arrows: true,
      breakpoints: {
        576: {
          perPage: 1,
          arrows: true,
        },
        768: {
          perPage: 2,
          arrows: true,
        },
        992: {
          perPage: 3,
        },
      },
    });

    logos.mount();
  }


});
